
// This file is maintained for backward compatibility
// Re-export everything from the new modular storage service
import { StorageService as ModularStorageService } from './storage/StorageService';
import type { 
  FileValidationResult, 
  StorageSettings, 
  UploadResult 
} from './storage/types';

// Create a class that mirrors the new StorageService for backward compatibility
class StorageService {
  static async uploadFile(
    file: File,
    bucket: string,
    path: string = ''
  ): Promise<UploadResult | null> {
    return ModularStorageService.uploadFile(file, bucket, path);
  }

  static async deleteFile(bucket: string, path: string): Promise<boolean> {
    return ModularStorageService.deleteFile(bucket, path);
  }

  static getPublicUrl(bucket: string, path: string): string {
    return ModularStorageService.getPublicUrl(bucket, path);
  }

  static async listFiles(bucket: string, path: string = ''): Promise<string[]> {
    return ModularStorageService.listFiles(bucket, path);
  }

  // Add the missing methods that are being used in other files
  static validateFile(file: File, maxSizeMB: number = 5, allowedTypes: string[] = []): FileValidationResult {
    return ModularStorageService.validateFile(file, maxSizeMB, allowedTypes);
  }

  static validateFileWithOptions(
    file: File, 
    options: { maxSizeInMB: number; fileType?: any }
  ): FileValidationResult {
    return ModularStorageService.validateFileWithOptions(file, options);
  }

  static async checkBucketExists(bucketName: string): Promise<boolean> {
    return ModularStorageService.checkBucketExists(bucketName);
  }

  static async createBucket(bucketName: string, isPublic: boolean = true): Promise<boolean> {
    return ModularStorageService.createBucket(bucketName, isPublic);
  }

  static async getStorageSettings(): Promise<StorageSettings> {
    return ModularStorageService.getStorageSettings();
  }

  static async ensureRequiredBuckets(): Promise<void> {
    return ModularStorageService.ensureRequiredBuckets();
  }
}

// Export the class and also as default
export { StorageService };
export default StorageService;
